import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/Authentication'
import Cart from './modules/Cart'
import Vehicles from './modules/Vehicles'
import Snackbar from './modules/Snackbar'
import Alert from './modules/Alert'
import Station from './modules/Station'
import Bookings from './modules/Bookings'
import SimpleBookings from './modules/SimpleBookings'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  getters,
  mutations,
  actions,
  modules: {
    Auth: {
      namespaced: true,
      ...Auth
    },
    Vehicles: {
      namespaced: true,
      ...Vehicles
    },
    SnackBar: {
      namespaced: true,
      ...Snackbar
    },
    Alert: {
      namespaced: true,
      ...Alert
    },
    Cart: {
      namespaced: true,
      ...Cart
    },
    Station: {
      namespaced: true,
      ...Station
    },
    Bookings: {
      namespaced: true,
      ...Bookings
    },
    SimpleBookings: {
      namespaced: true,
      ...SimpleBookings
    }
  },
  strict: true
})

// make store accessible in Cypress for e2e tests
if (window.Cypress) {
  window.__store__ = store
}

export default store
